import Cookies from 'js-cookie';

function doLogout() {
    Cookies.remove('session');
}

export default doLogout;